export default {
  SECURE_HOST: "https://jumbo81.com:19090",
  MESSAGE_LENGTH: 1024 * 1024 * 2
}